import { useState, useMemo } from 'react'
import { Outlet, Link, NavLink, useLoaderData } from 'react-router-dom'
import Pagination from '../components/pagination/Pagination'
import styles from './BlogPosts.module.scss'
import data from '../data/db.json'

let pageSize = 7;

const BlogPosts = () => {
  const [reverseOrder, setReverseOrder] = useState(false);
  const reversedData = reverseOrder ? [...data].reverse() : data;
  const [currentPage, setCurrentPage] = useState(1);

  const toggleOrder = () => {
    setReverseOrder(!reverseOrder);
  };

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    return reversedData.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, reverseOrder]);

  const postData = currentTableData.map(post => (
    <Link to={`/post/${post.id}`} key={post.id} className={styles.postLink}>
      <div className={styles.post}>
        <p>{post.date}:</p>
        <p className={styles.blogPostTittle}>{post.title}</p>
      </div>
    </Link>
  ));


  return (
    <>
      <div className={styles.blogPosts}>
        <div>
          <h2>Posts:</h2>
          <button onClick={toggleOrder} className={styles.orderBtn}>
            {reverseOrder ? 'Show Oldest First' : 'Show Newest First'}
          </button>
        </div>

        <Pagination
        className={styles.paginationBar}
        currentPage={currentPage}
        totalCount={data.length}
        pageSize={pageSize}
        onPageChange={page => setCurrentPage(page)}
      />

        {postData}


        <Outlet />



      </div>
    </>
  );
};

export default BlogPosts;

// //loaders, make funcion out side component

// export const blogPostsLoader = async () => {
//   const res = await fetch('http://localhost:4000/blogPosts');

//   return res.json();
// };